import { CustomApiHandler } from "@NA/Store/CustomHandlerCreator/CustomHandlerCreator";
import { getAccountBillToCollection } from "@NA/Services/ADIUserAdminSuffixInfosService";
import { HasOnError, HasOnSuccess, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import {
    AccountBillToCollectionModel,
    CustomAccountBillToModel,
    GetAccountBillToCollectionApiParameter,
} from "@insite/client-framework/Types/ApiModels";

type HandlerType = CustomApiHandler<
    GetAccountBillToCollectionApiParameter & HasOnSuccess & HasOnError,
    AccountBillToCollectionModel
>;

export const loadCustomerData: HandlerType = async props => {
    props.apiResult = await getAccountBillToCollection(props.parameter);
};

export const chain = [loadCustomerData];

const loadAllBillTos = createHandlerChainRunner(chain, "ADIUserAdminSuffixInfosHandler");
export default loadAllBillTos;
